import React, { useEffect, useState, useMemo } from "react";
import CountUp from "react-countup";
import axios from "axios";
import { Link, NavLink, useOutletContext, useParams } from "react-router-dom";
import { currency_converter_inr } from "../../../utils/currencyUtils";
import { MaterialReactTable } from "material-react-table";
import { decodeHtml } from "../../../utils/decodeHtml";
import { colors } from "@mui/material";

function ClientAccountAnalysis() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const [data, setData] = useState([]);
  const [optionsGroupBreakupOne, setOptionsGroupBreakupOne] = useState([]);
  const [optionsGroupBreakupTwo, setOptionsGroupBreakupTwo] = useState([]);
  const [optionsGroupBreakupThree, setOptionsGroupBreakupThree] = useState([]);
  const [options, setOptions] = useState([]);
  const [revenueHistory, setRevenueHistory] = useState([]);
  const [groupBreakup, setGroupBreakup] = useState([]);
  const {setGlobalLoading, token } = useOutletContext();
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const formatNumber = (num) => {
    if (!num) return 0;
    return new Intl.NumberFormat("en-IN").format(num);
    };
  async function fetchOptions() {
    setGlobalLoading(true);
    try {
        const response = await axios.get(
        `${API_BASE_URL}/reports/get_client_analysis/`,
        {
            headers: { Authorization: `Bearer ${token}` },
        }
        );
        setOptions(response.data.client_analysis || []);
        setOptionsGroupBreakupOne(response.data.group_breakup_current_year || []);
        setOptionsGroupBreakupTwo(response.data.group_breakup_previous_year || []);
        setOptionsGroupBreakupThree(response.data.group_breakup_previous_last_year || []);

        console.log(response.data.group_breakup_current_year);
  
        const d = response.data;
        if (response.status === 200) {
            setData({
            ...d,
            });
        }
    } catch (error) {
        console.error("API Error:", error);
        // setoptions([]);
    } finally {
        setGlobalLoading(false); 
    }
  }

  useEffect(() => {
    if (token) {
        fetchOptions();
    }
  }, [token]); 

  const fetchCompanyRevenue = async (companyId, financialYear) => {
    try {
        const response = await axios.get(
        `${API_BASE_URL}/reports/company_revenue_details/${companyId}`,
        {
            params: {
            financial_year: financialYear,
            },
            headers: {
            Authorization: `Bearer ${token}`,
            },
        }
        );
        setRevenueHistory(response.data.revenue_history);
        setGroupBreakup(response.data.group_breakup);
    } catch (error) {
        console.error(error);
    }
    };

    const groupedData = React.useMemo(() => {
    const result = {};

    options.forEach((item) => {
        if (!result[item.ranking]) {
        result[item.ranking] = {
            ranking: item.ranking,
        };
        }
        result[item.ranking][item.financial_year] = item;
    });
    return Object.values(result).sort((a, b) => a.ranking - b.ranking);
    }, [options]);

    const years = [
        ...new Set(options.map((x) => x.financial_year)),
        ].sort((a, b) => b.localeCompare(a));
   

    const handleCompanyClick = (company, year) => {
    setSelectedCompany(company);
    setShowModal(true);
    fetchCompanyRevenue(company.parent_company_id, year);
    };   

    const groupCompanies = (data) => {
        const groups = {};

        data.forEach((row) => {
            if (!groups[row.parent_id]) {
            groups[row.parent_id] = {
                parent_id: row.parent_id,
                parent_company: row.parent_company,
                total_revenue: row.total_revenue,
                children: [],
            };
            }

            if (row.row_type === "CHILD") {
            groups[row.parent_id].children.push(row);
            }
        });

        return Object.values(groups).sort(
            (a, b) => b.total_revenue - a.total_revenue
        );
        }; 
        
    const groupedCurrentYear = useMemo(
        () => groupCompanies(optionsGroupBreakupOne),
        [optionsGroupBreakupOne]
    );

    const groupedPreviousYear = useMemo(
        () => groupCompanies(optionsGroupBreakupTwo),
        [optionsGroupBreakupTwo]
    );

    const groupedTwoYearsBack = useMemo(
        () => groupCompanies(optionsGroupBreakupThree),
        [optionsGroupBreakupThree]
    );    
  

    const getFinancialYear = (offset = 0) => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;

    const fyStartYear = month >= 4 ? year : year - 1;

    return `${fyStartYear - offset}-${fyStartYear - offset + 1}`;
    };

    const currentFY = getFinancialYear(0);
    const previousFY = getFinancialYear(1);
    const previousPreviousFY = getFinancialYear(2);

    const GroupBreakupCard = ({ title, data }) => (
        <div className="col-md-4">
            <div className="card shadow-sm mb-4">
            <div className="card-header">
                <h5>{title}</h5>
            </div>

            <div className="card-body">
                <div className="table-responsive" style={{ maxHeight: "1000px" }}
                >
                <table className="table table-bordered">
                    <thead>
                    <tr>
                        <th className="client-column">Client</th>
                        <th className="amount-column">Amount</th>
                    </tr>
                    </thead>

                    <tbody>
                    {data.map((group) => (
                        <React.Fragment key={group.parent_id}>
                        <tr>
                            <td className="client-column">
                            <strong>{group.parent_company}</strong>
                            </td>
                            <td className="amount-column text-end">
                            <strong>
                                {formatNumber(group.total_revenue)}
                            </strong>
                            </td>
                        </tr>

                        {group.children.map((child) => (
                            <tr key={child.company_id}>
                            <td className="client-column ps-4">
                                ↳ {child.company_name}
                            </td>
                            <td className="amount-column text-end">
                                {formatNumber(child.company_revenue)}
                            </td>
                            </tr>
                        ))}
                        </React.Fragment>
                    ))}
                    </tbody>
                </table>
                </div>
            </div>
            </div>
        </div>
        );

    return (
        <>
        <style>
        {`
        .table {
            font-size: 12px;
            margin-bottom: 0;
          }
          .table th,
          .table td {
            padding: 4px 8px !important;
            white-space: nowrap;
            vertical-align: middle;
            line-height: 1.2;
          }
          .table-responsive {
            overflow: auto;
            max-height: 500px;
          }
          /* Header */
          thead th {
            position: sticky;
            top: 0;
            background: #f5f5f5 !important;
            z-index: 20;
            font-weight: 600;
          }
          /* 1st column - Unit Head */
          .sticky-col-1 {
            position: sticky;
            left: 0;
            background: #fff;
            z-index: 15;
            min-width: 100px;
          }
          /* 2nd column - Generated / Net Add */
          .sticky-col-2 {
            position: sticky;
            left: 100px;
            background: #fff;
            z-index: 15;
            min-width: 100px;
          }
          /* 3rd column - Revenue Total */
          .sticky-col-3 {
            position: sticky;
            left: 200px;
            background: #fff;
            z-index: 15;
            min-width: 140px;
          }
          /* Sticky header + sticky columns */
          thead .sticky-col-1,
          thead .sticky-col-2,
          thead .sticky-col-3 {
            background: #f5f5f5 !important;
            z-index: 25;
          }
          /* Optional border */
          .sticky-col-1,
          .sticky-col-2,
          .sticky-col-3 {
            box-shadow: 1px 0 0 #ddd;
          }
        .chart-box {
              min-height: 250px; /* adjust as needed */
              display: flex;
              flex-direction: column;
          } 
        .client-column {
            width: 70%;
            white-space: normal !important;
            word-break: break-word;
            }

        .amount-column {
            width: 30%;
            white-space: nowrap;
            }   
        `}
        </style>  
  
        <div className={`modal fade ${showModal ? "show d-block" : ""}`} tabIndex="-1" style={{backgroundColor: "rgba(0,0,0,0.5)",}}>
            <div className="modal-dialog modal-md">
                <div className="modal-content">

                <div className="modal-header">
                    <h5 className="modal-title">
                    Revenue Details
                    {selectedCompany && (
                        <> - {selectedCompany.group_company_name}</>
                    )}
                    </h5>

                    <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                    />
                </div>

                <div className="modal-body">
                    {selectedCompany && (
                        <>
                            <table className="table table-bordered mb-4">
                                <tbody>
                                    <tr>
                                        <td width="40%">
                                            <strong>Company</strong>
                                        </td>
                                        <td>
                                            {selectedCompany.group_company_name}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <strong>Current Revenue</strong>
                                        </td>
                                        <td>
                                            {formatNumber(selectedCompany.revenue)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div className="mt-3">
                                <h6 className="fw-bold border-bottom pb-2">
                                    REVENUE DETAILS
                                </h6>

                                <table className="table table-bordered table-sm">
                                    <tbody>
                                        {revenueHistory.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.financial_year}</td>
                                                <td className="text-end">
                                                    {formatNumber(item.revenue)}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="mt-4">
                                <h6 className="fw-bold border-bottom pb-2">
                                    GROUP BREAKUP [{revenueHistory?.[0]?.financial_year || ""}]
                                </h6>

                                <table className="table table-bordered table-sm">
                                    <tbody>
                                        {groupBreakup.map((item) => (
                                            <tr key={item.id}>
                                                <td>{item.company_name}</td>
                                                <td className="text-end">
                                                    {formatNumber(item.revenue)}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}
                </div>
                </div>
            </div>
        </div> 

        <div className="card shadow-sm mb-4">
        <div className="card-body">
            <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                <h5 className="mb-2 d-flex" style={{ flexDirection: "column" }}>
                    Key Client Analysis
                </h5>
            </div>
            <div className="row">
                    <div className="col-md-12 col-xl-12 col-xxl-12">
                        <div className="table-responsive" style={{ maxHeight: "700px" }}>
                        <table className="table text-nowrap table-bordered">
                            <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                            <tr>
                                {years.map((year) => (
                                <th key={year}>{year}</th>
                                ))}
                            </tr>
                            </thead>

                            <tbody>
                                {groupedData.map((row) => (
                                    <tr key={row.ranking}>
                                    {years.map((year) => {
                                        const company = row[year];

                                        return (
                                        <td key={year}>
                                            {company ? (
                                            <>
                                                <div>
                                                <a
                                                    href="#"
                                                    className="text-decoration-none fw-semibold"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleCompanyClick(company, year);
                                                    }}
                                                    >
                                                    {company.group_company_name}
                                                    </a>
                                                </div>

                                                <div className="text-end">
                                                {formatNumber(company.revenue)}
                                                </div>
                                            </>
                                            ) : (
                                            "-"
                                            )}
                                        </td>
                                        );
                                    })}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        </div>        
                    </div>
                </div>

        </div>
        </div>

        <div className="row">
            <GroupBreakupCard
                title={`Client Group Break ups (${currentFY})`}
                data={groupedCurrentYear}
            />

            <GroupBreakupCard
                title={`Client Group Break ups (${previousFY})`}
                data={groupedPreviousYear}
            />

            <GroupBreakupCard
                title={`Client Group Break ups (${previousPreviousFY})`}
                data={groupedTwoYearsBack}
            />
        </div>

        </>
    );
}

export default ClientAccountAnalysis;